<script lang="ts">
    import {getInjector} from 'src/core';
    import {Flex} from 'shared/layouts';
    import type {ReportTemplate} from 'src/typings';
    import {getProjectReportOptimisationContext} from '../../project-report-optimisation-context';
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import ReportServerService from 'src/features/report-server/services/report-server.service';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    interface PrintButtonSettings {
        templateName: string;
        label: string;
        recordId: string;
        disabled: boolean;
    }

    export let heading: string;
    export let printButtonSettings: PrintButtonSettings;
    const reportServerService = getInjector().getByClass(ReportServerService);
    const context = getProjectReportOptimisationContext();

    let loadedTemplateName = '';
    let loadedTemplate: ReportTemplate | null = null;
    let mounted = false;
    let isLoading = true;

    onMount(() => {
        mounted = true;
    });

    $: if (mounted && printButtonSettings.templateName !== loadedTemplateName && !printButtonSettings.disabled) {
        loadTemplate(printButtonSettings.templateName);
        loadedTemplateName = printButtonSettings.templateName;
    }

    async function loadTemplate(name: string) {
        isLoading = true;
        loadedTemplate = await context.service.getReportServerTemplateByName(name);
        isLoading = false;
    }

    const handlePrintClick = async () => {
        await reportServerService.downloadExport(loadedTemplate, {
            recordId: printButtonSettings.recordId
        });
    };
</script>

<Flex class="optimisation-overview-heading" justifyContent="space-between" alignItems="flex-end">
    <span class="overview-heading">{heading}</span>

    <KpButton isDisabled={printButtonSettings.disabled || !exists(loadedTemplate)} {isLoading} buttonStyle="primary" on:click={handlePrintClick}>
        <IconedContent icon="print">{printButtonSettings.label}</IconedContent>
    </KpButton>
</Flex>

<style>
    .overview-heading {
        font-weight: 500;
    }
</style>